// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Visit ${i.handle} on Facebook`
};

const de_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Besuche ${i.handle} auf Facebook`
};

const es_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Visitar ${i.handle} en Facebook`
};

const fr_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Visiter ${i.handle} sur Facebook`
};

const fi_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Vieraile ${i.handle} Facebookissa`
};

const hi_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Facebook पर ${i.handle} को देखें`
};

const ja_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Facebookで${i.handle}を訪問`
};

const nl_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Bezoek ${i.handle} op Facebook`
};

const pt_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Visitar ${i.handle} no Facebook`
};

const ro_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Vizitează ${i.handle} pe Facebook`
};

const th_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `เยี่ยมชม ${i.handle} บน Facebook`
};

const ur_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `${i.handle} کو فیس بک پر دیکھیں`
};

const zh_hant1_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `訪問 ${i.handle} 的 Facebook 粉絲專頁`
};

const da_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Besøg ${i.handle} på Facebook`
};

const it_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Visita ${i.handle} su Facebook`
};

const vn_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Thăm ${i.handle} trên Facebook`
};

const ko_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Facebook에서 ${i.handle} 방문하기`
};

const tr_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Facebook'ta ${i.handle} sayfasını ziyaret et`
};

const lv_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Apmeklējiet ${i.handle} Facebook`
};

const ar_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `زر ${i.handle} على فيسبوك`
};

const bs_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Posjetite ${i.handle} na Facebooku`
};

const sl_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Obiščite ${i.handle} na Facebooku`
};

const id_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Kunjungi ${i.handle} di Facebook`
};

const sv_widget_actions_visit_facebook_page = /** @type {(inputs: { handle: NonNullable<unknown> }) => string} */ (i) => {
	return `Besök ${i.handle} på Facebook`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ handle: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_actions_visit_facebook_page = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_actions_visit_facebook_page(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_actions_visit_facebook_page", locale)
	if (locale === "en") return en_widget_actions_visit_facebook_page(inputs)
	if (locale === "de") return de_widget_actions_visit_facebook_page(inputs)
	if (locale === "es") return es_widget_actions_visit_facebook_page(inputs)
	if (locale === "fr") return fr_widget_actions_visit_facebook_page(inputs)
	if (locale === "fi") return fi_widget_actions_visit_facebook_page(inputs)
	if (locale === "hi") return hi_widget_actions_visit_facebook_page(inputs)
	if (locale === "ja") return ja_widget_actions_visit_facebook_page(inputs)
	if (locale === "nl") return nl_widget_actions_visit_facebook_page(inputs)
	if (locale === "pt") return pt_widget_actions_visit_facebook_page(inputs)
	if (locale === "ro") return ro_widget_actions_visit_facebook_page(inputs)
	if (locale === "th") return th_widget_actions_visit_facebook_page(inputs)
	if (locale === "ur") return ur_widget_actions_visit_facebook_page(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_actions_visit_facebook_page(inputs)
	if (locale === "da") return da_widget_actions_visit_facebook_page(inputs)
	if (locale === "it") return it_widget_actions_visit_facebook_page(inputs)
	if (locale === "vn") return vn_widget_actions_visit_facebook_page(inputs)
	if (locale === "ko") return ko_widget_actions_visit_facebook_page(inputs)
	if (locale === "tr") return tr_widget_actions_visit_facebook_page(inputs)
	if (locale === "lv") return lv_widget_actions_visit_facebook_page(inputs)
	if (locale === "ar") return ar_widget_actions_visit_facebook_page(inputs)
	if (locale === "bs") return bs_widget_actions_visit_facebook_page(inputs)
	if (locale === "sl") return sl_widget_actions_visit_facebook_page(inputs)
	if (locale === "id") return id_widget_actions_visit_facebook_page(inputs)
	if (locale === "sv") return sv_widget_actions_visit_facebook_page(inputs)
	return "widget_actions_visit_facebook_page"
};